import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CheckBoxText } from '../../../model/myria/CheckBoxText';

@Component({
  selector: 'checkbox-text',
  templateUrl: 'checkbox-text.html'
})
export class CheckboxTextComponent {

  @Input() checkBoxMsg: CheckBoxText = new CheckBoxText();
  @Output() checkboxEmitter = new EventEmitter<any>();
  checkbox:boolean;

  constructor() {
  }

  emit(){
    this.checkboxEmitter.emit(this.checkbox);
  }

}



// WEBPACK FOOTER //
// ./src/components/myria/checkbox-text/checkbox-text.ts